import type { InjectionKey } from 'vue';

/**
 * Provided by the Connect shell (`true`) when sub-apps render inside it.
 * Sub-app sidebars use this to hide their footer (user-card / UserMenu)
 * because the shell already shows a global avatar + account menu in the
 * left rail.
 */
export const NxSidebarEmbeddedKey: InjectionKey<boolean> = Symbol('NxSidebarEmbedded');
